export const tierIndex = {
  "Tier I": 0,
  "Tier II": 1,
  "Tier III": 2,
  "Tier IV": 3,
  "N/A": 4,
};
export const tierLabels = ["Tier I", "Tier II", "Tier III", "Tier IV", "N/A"];
